import React, { useRef, useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  Box,
  Button,
  Grid,
  Tooltip,
  Typography,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import LoadingButton from '@mui/lab/LoadingButton';
import CertifiedStampPreview from '../G04docuSubMatTemplate/CertifiedStampPreview';
import { CERTIFIED_STAMP_COLOR, CERTIFIED_STAMP_FORM_WIDTH } from '../G04docuSubMatTemplate/certifiedStampSpec';
import {
  CloudUpload,
  DeleteOutline,
} from '@mui/icons-material';
import { AlertDialog, ConfirmDialog } from "../dialog";
import * as sessionActions from "../../store/session";
import * as gclientActions from "../../store/gclient";

const CertifiedBox = ({
  // max = 10,
  max = 1,
  control,
  setValue,
  getValues,
  defaultValues,
}) => {
  const [URLThumbnail, setURLThumbnail] = useState("");
  // const [files, setFiles] = useState([]);
  const [loadingAdd, setLoadingAdd] = useState(false);
  const [loadingDelete, setLoadingDelete] = useState(false);
  const [confirmOpenDelete, setConfirmOpenDelete] = useState(false);
  const [alertInfo, setAlertInfo] = useState({});

  const sessionUser = useSelector((state) => state.session.sessionUser);
  const sessionUserLoginType = useSelector((state) => state.session.sessionUser.sessionUserLoginType);
  const sessionUserRole = useSelector((state) => state.session.sessionUser.role);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const canEdit = sessionUserRole === 'ADMIN_ROLE';

  const uploadFile = (gclientId, formData) => gclientActions.uploadFileDirect(gclientId, formData)
  const downloadFile = (documentPath) => gclientActions.downloadDirect(documentPath)
  const removeFile = (gclientId, documentPath) => gclientActions.removeDirect(gclientId, documentPath)

  const dispatch = useDispatch();

  const updateSessionUser = (gclient) => dispatch(sessionActions.updateSessionUser(gclient))
  const restoreSessionUser = () => dispatch(sessionActions.restoreSessionUser())

  const [uploadBoxStyle, setUploadBoxStyle] = useState({ border: 1, borderRadius: 2, borderColor: 'divider' });

  const uploadBoxRef = useRef();
  const inputRef = useRef();

  // const uploadBox = uploadBoxRef.current;
  // const input = inputRef.current;

  // event handler
  const fileTypes = ["png", "jpeg", "bmp", "jpg", "gif"];
  
  const dragOverHandler = (event) => {
    event.preventDefault();
    event.stopPropagation();
    
    setUploadBoxStyle({ border: 1, borderRadius: 2, borderColor: '#1565c0', backgroundColor: '#e1f5fe' })
  };
  const dragLeaveHandler = (event) => { setUploadBoxStyle({ border: 1, borderRadius: 2, borderColor: 'divider' }); }
  const mouseOverHandler = (event) => { setUploadBoxStyle({ border: 1, borderRadius: 2, borderColor: '#1565c0', backgroundColor: '#e1f5fe' }); }
  const mouseLeaveHandler = (event) => { setUploadBoxStyle({ border: 1, borderRadius: 2, borderColor: 'divider' }); }
  // 

  useEffect(
    () => {
      const uploadBox = uploadBoxRef.current;
      const input = inputRef.current;
      
      // const handleFiles = (files) => {
      //   for (const file of files) {
      //     if (!file.type.startsWith("image/")) continue;
      //     const reader = new FileReader();
      //     reader.onloadend = (e) => {
      //       const result = e.target.result;
      //       if (result) {
      //         setUploadedImages((state) => [...state, result].slice(0, max));
      //       }
      //     };
      //     reader.readAsDataURL(file);
      //   }
      // };
      
      // const changeHandler = (event) => {
      //   event.preventDefault();
      //   event.stopPropagation();
      //   const files = event.target.files;
      //   handleFiles(files);
      // };
      
      // const dropHandler = (event) => {
      //   event.preventDefault();
      //   event.stopPropagation();
      //   const files = event.dataTransfer.files;
      //   handleFiles(files);
      // };
      const createImageURLAndUpload = async (fileBlob) => {  // createObjectURL 방식
        // console.log(fileBlob)
        if (URLThumbnail) {
          URL.revokeObjectURL(URLThumbnail);
        }
        
        setLoadingAdd(true);

        // handleClicUpload();
        const formData = new FormData();
              formData.append('gclientName', sessionUser.name);
              formData.append('images', fileBlob);
              formData.append('fileName', fileBlob.name); // TODO : 한글 파일명인 경우 서버에서 인코딩 문제가 발생. 현재 해결 못하여 fileName을 설정함
        // console.log(Object.fromEntries(formData.entries()))
        // console.log(gclient)
        try {
          const signDocumentPath = await uploadFile(sessionUser.id, formData);
          // console.log(signDocumentPath)
  
          // setFiles([]);
  
          // updateSessionUser({
          //   ...sessionUser,
          //   signDocumentPath,
          // });
          restoreSessionUser();
  
          const url = URL.createObjectURL(fileBlob);
          setURLThumbnail(url);
          // setFiles([fileBlob]);
  
          setLoadingAdd(false);
        } catch (e) {
          // TODO : 에러처리
        }
      };

      const dropHandler = (e) => {
        e.preventDefault();
        e.stopPropagation();
    
        setUploadBoxStyle({ border: 1, borderRadius: 2, borderColor: 'divider' })
    
        const { files } = e.dataTransfer;
    
        if (!files || !files[0]) return;
        
        if (files.length > 1) {
          setAlertInfo({
            titleAlert: "안내",
            messageAlert: "하나의 파일만 선택해주세요.",
            open: true,
          });

          return;
        }

        const { type } = files[0];
        
        const matches = fileTypes.filter(fileType => type.indexOf(fileType) > 0);
        if (matches.length === 0) {
          setAlertInfo({
            titleAlert: "안내",
            messageAlert: (<><span style={{ color: "#1976d2" }}>{fileTypes.join(", ")}</span>{" 파일만 사용이 가능합니다."}</>),
            open: true,
          });
          return;
        }
        
        createImageURLAndUpload(files[0]);
      };


      const changeHandler = async (e) => {        
        e.preventDefault();
        e.stopPropagation();
    
        const { files } = e.target;
        console.log(files)
    
        if (!files || !files[0]) return;
        
        if (files.length > 1) {
          setAlertInfo({
            titleAlert: "안내",
            messageAlert: "하나의 파일만 선택해주세요.",
            open: true,
          });

          e.target.value = ''; // 같은 파일을 올리면 onChange 이벤트가 발생하지 않으므로 초기화

          return;
        }

        const { type } = files[0];
        
        const matches = fileTypes.filter(fileType => type.indexOf(fileType) > 0);
        if (matches.length === 0) {
          setAlertInfo({
            titleAlert: "안내",
            messageAlert: (<><span style={{ color: "#1976d2" }}>{fileTypes.join(", ")}</span>{" 파일만 사용이 가능합니다."}</>),
            open: true,
          });

          e.target.value = ''; // 같은 파일을 올리면 onChange 이벤트가 발생하지 않으므로 초기화

          return;
        }

        createImageURLAndUpload(files[0]);
    
        e.target.value = ''; // 같은 파일을 올리면 onChange 이벤트가 발생하지 않으므로 초기화
      };
      
      if (!uploadBox || !input) return;

      uploadBox.addEventListener("drop", dropHandler);
      uploadBox.addEventListener("dragover", dragOverHandler);
      uploadBox.addEventListener("dragleave", dragLeaveHandler);
      uploadBox.addEventListener("mouseover", mouseOverHandler);
      uploadBox.addEventListener("mouseleave", mouseLeaveHandler);
      
      input.addEventListener("change", changeHandler);
      
      return () => {
        uploadBox.removeEventListener("drop", dropHandler);
        uploadBox.removeEventListener("dragover", dragOverHandler);
        uploadBox.removeEventListener("dragleave", dragLeaveHandler);
        uploadBox.removeEventListener("mouseover", mouseOverHandler);
        uploadBox.removeEventListener("mouseleave", mouseLeaveHandler);
        
        input.removeEventListener("change", changeHandler);
      };
    }, [max, URLThumbnail]
  );
  
  // useEffect(() => {
  //   async function fetchData() {
  //     // You can await here
  //     const response = await MyAPI.getData(someId);
  //     // ...
  //   }
  //   fetchData();
  // }, [someId]); // Or [] if effect doesn't need props or state
  useEffect(() => {
    // console.log(sessionUser)
    const { signDocumentPath } = sessionUser;

    if (signDocumentPath) {
      async function load () {
        const res = await downloadFile(signDocumentPath);
        const blob = await res.blob(); // res.blob()는 비동기 함수이므로 await 필요
        const url = URL.createObjectURL(blob);
        setURLThumbnail(url);
        // setFiles([blob]);
      }
      load();
    }
  }, [sessionUser])
  
  // useEffect(
  //   () => {
  //     const imageJSXs = uploadedImages.map((image, index) => {
  //       const isDeleteImage = (element) => {
  //         return element === image;
  //       };
  //       const deleteFunc = () => {
  //         uploadedImages.splice(uploadedImages.findIndex(isDeleteImage), 1);
  //         setUploadedImages([...uploadedImages]);
  //       };
  //       return <ImagePreview image={image} deleteFunc={deleteFunc} key={index} />;
  //     });
  //     setPreviewImages(imageJSXs);
  //   }, [uploadedImages]
  // );

  // const handleClicUpload = async () => {
  //   // console.log(files)

  //   const formData = new FormData();
  //         formData.append('gclientName', sessionUser.name);
  //         formData.append('images', files[0]);
  //         formData.append('fileName', files[0].name); // TODO : 한글 파일명인 경우 서버에서 인코딩 문제가 발생. 현재 해결 못하여 fileName을 설정함

  //   // console.log(gclient)
  //   const signDocumentPath = await uploadFile(sessionUser.id, formData);
  //   // console.log(signDocumentPath)

  //   // setFiles([]);

  //   updateSessionUser({
  //     ...sessionUser,
  //     signDocumentPath,
  //   });

  //   // FormData는 브라우저 정책상 console.log로 출력안되므로 아래와 같이 햐여 값을 볼 수 있다.
  //   // for (let [index, value] of formData) {
  //   //   console.log({ index, value})
  //   // }
  // }

  const handleClickDelete = () => {
    setConfirmOpenDelete(true);
  };

  const handleConfirmDelete = async () => {
    const { id, signDocumentPath } = sessionUser;
    if (signDocumentPath) {
      setLoadingDelete(true);
      await removeFile(id, signDocumentPath); // 서버에서 파일 삭제
      setTimeout(() => setLoadingDelete(false), 1000);
    }

    URL.revokeObjectURL(URLThumbnail);
    
    setURLThumbnail("");

    // updateSessionUser({
    //   ...sessionUser,
    //   signDocumentPath: null,
    // });
    restoreSessionUser();
    // setFiles([]);
  }

  const handleChangeSupplierLabel = (e) => {
    const { value } = e.target;
    // console.log(value)
    if (value) {
      setValue("supplierLabel", value);  
    } else {
      // setValue("supplierLabel", defaultValues.supplierLabel);
      setValue("supplierLabel", "");
    }
  }

  const handleChangeSupplier = (e) => {
    const { value } = e.target;
    // console.log(value)
    if (value) {
      setValue("supplier", value);  
    } else {
      // setValue("supplier", "제공사");
      setValue("supplier", "");
    }
  }

  const handleChangePhrase = (e) => {
    const { value } = e.target;
    // console.log(value)
    if (value) {
      setValue("phrase", value);
    } else {
      // setValue("phrase", `이 문서는 ${getValues("supplier")}가 제출처에게 발행한 문서입니다.`);
      setValue("phrase", "");
    }
  }
  
  const handleClickTextInit = () => {
    setValue("supplierLabel", "제공사");
    setValue("supplier", sessionUser.name);
    // setValue("phrase", `이 문서는 ${sessionUser.name}가 제출처에게 발행한 문서입니다.`);
    setValue("phrase", `본 문서는 원본과 같음을 확인하며, 상기 현장 외에 사용을 금합니다.`);
  }

  return (
    <Box>
      {/* label로 input과 결합 */}
      <Grid container spacing={1}>
        <Grid item xs={12} sx={{ display: canEdit ? "flex" : "none", justifyContent: "center" }}>
          <Box sx={{ width: "100%", maxWidth: CERTIFIED_STAMP_FORM_WIDTH }}>
            {URLThumbnail ? (
              <LoadingButton
                variant="text"
                onClick={handleClickDelete}
                loading={loadingDelete}
                startIcon={<DeleteOutline fontSize="small" />}
                fullWidth
                sx={{
                  height: isMobile ? 48 : 40,
                  color: CERTIFIED_STAMP_COLOR,
                  textTransform: "none",
                  fontSize: "1rem",
                }}
              >
                {"인감삭제"}
              </LoadingButton>
            ) : (
              <Tooltip title="여기에 파일을 놓거나 누르세요." disableHoverListener={isMobile} disableFocusListener={isMobile} disableTouchListener>
                <LoadingButton
                  variant="text"
                  loading={loadingAdd}
                  fullWidth
                  sx={{
                    height: isMobile ? 48 : 40,
                    color: CERTIFIED_STAMP_COLOR,
                    textTransform: "none",
                    fontSize: "1rem",
                  }}
                >
                  <label htmlFor={"input_image"} ref={uploadBoxRef} style={{ width: "100%", cursor: "pointer", display: "inline-flex", alignItems: "center", justifyContent: "center", gap: 8 }}>
                    <CloudUpload fontSize="small" />
                    {"인감등록"}
                  </label>
                  <input hidden
                    type="file"
                    multiple
                    accept=".png,.jpeg,.bmp,.jpg,.gif"
                    id={"input_image"}
                    ref={inputRef}
                  />
                </LoadingButton>
              </Tooltip>
            )}
          </Box>
        </Grid>
        <Grid item xs={12} sx={{ display: 'flex', justifyContent: 'center' }}>
          <CertifiedStampPreview
            control={control}
            signThumbnailUrl={URLThumbnail}
            templateEdit
            readOnly={!canEdit}
            onChangeSupplierLabel={handleChangeSupplierLabel}
            onChangeSupplier={handleChangeSupplier}
            onChangePhrase={handleChangePhrase}
          />
        </Grid>
        <Grid item xs={12} sx={{ display: canEdit ? "" : "none" }}>
          <Box sx={{ display: 'flex', justifyContent: 'center' }}>
            <Button
              variant="text"
              onClick={handleClickTextInit}
              fullWidth={isMobile}
              sx={{ height: isMobile ? 48 : 'auto', textTransform: 'none', fontSize: '1rem' }}
            >
              {"기본 문구로 채우기"}
            </Button>
          </Box>
          <Typography variant="body2" color="text.secondary" align="center" sx={{ mt: 1 }}>
            {"제공사·문구를 고치거나 기본 문구로 채운 내용은 화면만 바뀝니다. 아래 문구 저장을 눌러야 반영됩니다."}
          </Typography>
        </Grid>
      </Grid>
      <AlertDialog
        alertInfo={alertInfo}
        setAlertInfo={setAlertInfo}
      />
      <ConfirmDialog
        title={"삭제"}
        open={confirmOpenDelete}
        setOpen={setConfirmOpenDelete}
        onConfirm={handleConfirmDelete}
        onCancel={() => {}}
      >
        {"인감을 삭제하시겠습니까?"}
      </ConfirmDialog>
    </Box>
  )
}

export default CertifiedBox;